import React from 'react'

export default function Postings() {
  return (
    <div>
        Postings      
    </div>
  )
}
